export const defaultCollectionName = 'default';

export const inputClassName = 'ba b--silver bg-white w-100 br2';

export const ElementTypes = {
  isProp: 'PROP',
  isCalc: 'CALC',
  isAggr: 'AGGR',
  isVal: 'VAL',
  isWF: 'WF',
};
